<template>
	<ul class="order-content">
		<li class="order-detail">
		    <div class="link-wrap" v-if="detailList.order_details">
		    	<img src="../assets/images/home/ic_home_line_5.png" alt="" class="pt-img"/>
		        <span class="link">情况备注</span>
		    </div>
		    <!-- <span class="un-connection" v-if="detailList.order_details_tag">{{detailList.order_details_tag}}</span> -->
		    <p class="describe" v-if="detailList.order_details">{{detailList.order_details}}</p>
		</li>
		
		<li class="order-detail p-b" v-if="roleName != 'sale' && (detailList.after_sale_name || detailList.other_sale_massage)" >
		    <div class="link-wrap">
		    	<img src="../assets/images/home/ic_home_line_4.png" alt="" class="pt-img"/>
		        <span class="link">售后特权</span> 
		    </div>
		    
		    <div class="customer-info" v-if="detailList.after_sale_type==2">
		        <span class="info-style">最大允许补偿金额</span>
		        <span class="info-style">¥{{detailList.compensation_price}}</span>
		    </div>
			
			<div class="customer-info" v-else-if="detailList.after_sale_type==4">{{detailList.other_sale_massage}}</div>
			
			<div class="customer-info f-s" v-else>{{detailList.after_sale_name}}</div>
		</li>
	</ul>
</template>

<script>
    export default {
		props:{
			detailList:{
				type: Object,
			}
		},
        name: 'AfterSale',
		data() {
		    return {
		      roleName: ''
		    };
		  },
		  created() {
		    this.roleName = sessionStorage.getItem('roleName');
		  }
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{font-family:PingFangSC-Regular;font-weight:400;background:#F5F5F5}
	.order-detail{margin-bottom: 10px;background: #fff}
	.link-wrap{font-size: 0;height: 1.38666667rem;margin: 0 10px;line-height: 1.38666667rem;border-bottom: 0.026667rem solid #EEEEEE;}
	.link{display: inline-block;vertical-align: middle;color:rgba(20,20,20,1);font-size: 0.4rem;font-weight: 600;}
	.pt-img{height: 20px;margin-right: 8px;display: inline-block;vertical-align:middle}
	.customer-info{padding: 10px 10px 2px 10px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center;}
	.info-style{color:rgba(74,74,74,1);font-size: 14px}
	.un-connection{display: inline-block;color:rgba(65,132,244,1);font-size: 13;padding:5px 17px;background:rgba(239,247,255,1);border-radius:4px;margin: 11px 0 9px 10px}
	.describe{color:rgba(74,74,74,1);font-size: 14px;padding: 8px 10px 8px 10px;}
	.img-list{display: -webkit-box;display: -ms-flexbox;display: flex;flex-wrap: wrap;padding:0 10px}
	.img-size{width: 78px;height:78px;margin-right: 7.5px;padding-bottom: 7.5px}
	.img-list .img-size:nth-child(4n){margin-right: 0}
	.p-b{padding-bottom:8px}
	.f-s{color: #4a4a4a;font-size: 0.373333rem;}
	.show-link{padding-left: 0.266667rem;}
</style>
